export default {"src":"/_next/static/media/whatsapp.26014ace.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};